import '@core/interceptors/bpc-api-interceptors';
import { VueConstructor } from 'vue';
import PosService from './services/pos-service';
declare module 'vue/types/vue' {
  interface Vue {
    // $posService: PosService;
    $posService: PosService;
  }
}

export default class SubscriptionsModule {
  static install(Vue: VueConstructor<Vue>): void {
    Vue.prototype.$posService = new PosService();
    console.log('initiating Point of sale module');
  }
}
